import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';
import { CoreFiltersModule} from '../../core/core.filters.module'
import { CoreWidgetsModule} from '../../widgets/core.widgets.module'
import { FORUM_STATES } from './forum.routes.config';

import { ForumService } from './forum.service';
import { ForumResolvesService } from './forum-resolves.service';
import { MessagesComponent } from './reader/messages/messages.component';
import { ForumReaderViewComponent } from './reader/forum.reader.component';
import { ForumThreadDeleteModalComponent }  from './reader/deleteThreadModal/delete.thread.modal.component';
import { ForumReaderToolbarComponent } from './reader-toolbar/forum.reader-toolbar.component';
import { ForumEditModalComponent } from './edit/forum.edit-modal.component';
import { ThreadEditModalComponent } from './thread-edit/forum.thread-edit-modal.component';
import { ForumSummaryViewComponent } from './summary/forum.summary.component';
import { ForumDeleteModalComponent } from './forum-delete/forum.delete.modal';

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        CoreFiltersModule,
        CoreWidgetsModule,
        UIRouterModule.forChild({ states: FORUM_STATES })
    ],
    providers: [
        ForumService,
        ForumResolvesService
    ],
    exports: [
        MessagesComponent,
        ForumReaderViewComponent,
        ForumThreadDeleteModalComponent,
        ForumReaderToolbarComponent,
        ForumEditModalComponent,
        ThreadEditModalComponent,
        ForumSummaryViewComponent,
        ForumDeleteModalComponent
    ],
    declarations: [
        MessagesComponent,
        ForumReaderViewComponent,
        ForumThreadDeleteModalComponent,
        ForumReaderToolbarComponent,
        ForumEditModalComponent,
        ThreadEditModalComponent,
        ForumSummaryViewComponent,
        ForumDeleteModalComponent
    ],
})
export class ForumModule {
    constructor() { }
}